<script>
import RightBar from "@/components/right-bar";
import router from "../../router/index"
import moment from "moment"
import StateConfirmPopup from "../../components/state-confirm-popup.vue";
import PermissionTooltip from "../../components/permission-tooltip.vue";
import { daysOfWeek } from '@/utils/utilsDate';
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';

import { layoutComputed, authWellyMethods } from "@/state/helpers";

export default {
  props: {},
  components: {
    RightBar,
    StateConfirmPopup,
    PermissionTooltip,
  },
  data() {
    return {
      showTooltipError: false,
      showTooltipErrorView: false,
      title: '',
      loader: true,
      timeNow: '',
      path: '',
      stateAvailable: null,
      nameResto: '',
      firstTitle: '',
      store: '',
      earliest: null,
      latest: null,
      showPopUpConfirm: false,
      menuOpen: false, // Control manual del dropdown
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    ...authWellyMethods,
    canUpdateStoreOpen() {
      return checkPermission(permissionsMap.UPDATE_STORE_OPEN, this.$store.state.permissions);
    },
    canViewPermissions() {
      const role = JSON.parse(localStorage.getItem('user'))?.data?.user?.role;
      return role.includes('Administrador')
    },
    openPopUpConfirm(event) {
      event.preventDefault()
      this.showPopUpConfirm = true
    },
    changeAvailable() {
      this.showPopUpConfirm = false
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    getTime() {
      this.timeNow = moment().format("HH:mm:ss")
      setTimeout(this.getTime, 1000);
    },
    logout() {
      this.stateAvailable = true
      this.changeAvailable()
      localStorage.clear();
      window.location = "/login";
    },
    toProduct() {
      this.menuOpen = false;
      router.push({ path: '/welly/my-dishes?title=Agregá productos y editá tu menú.' })
    },
    toPromos() {
      this.menuOpen = false;
      router.push({ path: '/welly/promos?title=Agrega promos y descuentos para obtener más ventas' })
    },
    toHome() {
      this.menuOpen = false;
      router.push({ path: '/welly/resto?title=Estos son tus wellys del día' })
    },
    toHistory() {
      this.menuOpen = false;
      router.push({ path: '/welly/history?title=Historial' })
    },
    toPermissions() {
      this.menuOpen = false;
      router.push({ path: '/welly/permission?title=Establece los permisos para tus colaborades' })
    },
    toSchedule() {
      this.menuOpen = false;
      router.push({ path: '/welly/schedule?title=Establece los horarios para tu negocio' })
    },
    toSupport() {
      this.menuOpen = false;
      const phoneNumber = '+5491133550948';
      const url = `https://wa.me/${phoneNumber}`;
      window.open(url, '_blank');
    },
    async getInfoResto() {
      const userItem = localStorage.getItem('user');
      const user = userItem ? JSON.parse(userItem).data.user : null;

      const storeItem = localStorage.getItem('store');
      const store = storeItem && storeItem !== "undefined" 
                    ? JSON.parse(storeItem) 
                    : {"name": user.name, "isOpen": false};

      this.store = store;
      this.nameResto = store.name;

      this.getTitleName();
    },
    getTitleName() {
      if (this.$route.path.includes('my-dishes')) {
        this.firstTitle = "Mis platos"
        this.title = 'Agregá productos y editá tu menú.'
      } else if (this.$route.path.includes("schedule")) {
        this.firstTitle = "Mis horarios"
      }  else if (this.$route.path.includes("permission")) {
        this.firstTitle = "Permisos"
      }
      else {
        this.firstTitle = `¡Hola ${this.nameResto != undefined ? this.nameResto : "bienvenido"}!`
        this.title = 'Estos son tus wellys del día.'
      }
    },
    updateStateAvailable(newState) {
      this.stateAvailable = newState;
    },
    Today() {
      this.nameToday = moment.utc().format('dddd').toLowerCase();
      this.nameToday = this.nameToday.charAt(0).toUpperCase() + this.nameToday.slice(1).toLowerCase();
      const indexToday = daysOfWeek.indexOf(this.nameToday);
      this.today = indexToday;
      const store = JSON.parse(localStorage.getItem('store'));
      const storeSchule = store.schedule;
      if(!storeSchule) { 
        this.earliest = null;
        this.latest = null;
        return;
      }

      const filteredByDay = storeSchule.filter(entry => entry.day === this.today);
      this.stateAvailable = filteredByDay[0]?.isAvailable ?? false;


      if (filteredByDay.length > 0) {
        let earliestTime = null;
        let latestTime = null;

    filteredByDay.forEach(dayEntry => {

        dayEntry.hours.forEach(hour => {
            const startTime = moment.utc(hour.open, 'HH:mm');
            const endTime = moment.utc(hour.close, 'HH:mm');

            if (!earliestTime || startTime.isBefore(earliestTime)) {
                earliestTime = startTime;
            }

            if (!latestTime || endTime.isAfter(latestTime)) {
                latestTime = endTime;
            }
        });
    });

    this.earliest = earliestTime ? earliestTime.format('HH:mm') : null;
    this.latest = latestTime ? latestTime.format('HH:mm') : null;

  }
    },
  toggleMenu() {
    if (this.menuOpen) {
      // cerrar normal → leave funciona bien
      this.menuOpen = false
    } else {
      // forzar frame inicial para que dispare enter
      this.menuOpen = false
      this.$nextTick(() => {
        this.menuOpen = true
      })
    }
  }
  },
  watch: {
    menuOpen(newVal) {
      if (newVal) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  },
  mounted() {
    this.loader = true;
    this.Today()
    this.getInfoResto()
    this.getTime()
    this.canViewPermissions()
    this.canUpdateStoreOpen()
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let title = urlParams.get('title');
    this.title = (title != null && title != '') ? title : '';
    this.path = window.location.pathname;
    this.changeAvailable()

    document.getElementById("preloader").style.display = "block";
    document.getElementById("status").style.display = "block";
    this.showTooltipError = false;

    setTimeout(() => {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
        this.loader = false;
        this.showTooltipError = true;
      }, 2500);
    },
  destroyed() {
    document.body.classList.remove('no-scroll');
  },
};
</script>

<template>
  <div class="horizontal">
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <div style="background-color:#FFF;">
        <br />

        <div class="row" style="margin: 0 10px 0 10px;">
          <div class="col-lg-6" style="text-align:left">
            <img src="@/assets/images/logo.gif" alt height="35" />
            &nbsp;
            <span style="color: #2DA673;">
              <b>Welly Go </b>
            </span>
            <span style="color: #EE6C3F;">
              <b>Restó</b>
            </span>
          </div>
          <div class="col-lg-6" style="text-align:right">
            <b>{{ timeNow }}</b>
          </div>
          <hr />
        </div>

        <div class="row horizontal-nav">
          <div class="col-lg-6" style="text-align:left">
            <!-- Dropdown con control manual -->
            <div class="custom-dropdown-wrapper">
              <button 
                class="btn btn-md btn-success btn-menu me-2"
                @click="toggleMenu"
              >
                <img src="@/assets/images/menu/bars.png" alt height="18" style="width: 18px;" />
              </button>

              <transition name="dropdown-fade">
                <div v-if="menuOpen" class="custom-dropdown-menu">
                  <div class="menu-top-button">
                    <button 
                      class="btn btn-md btn-success btn-menu me-2"
                      @click="toggleMenu"
                    >
                      <img src="@/assets/images/menu/bars.png" alt height="18" style="width: 18px;" />
                    </button>
                  </div>
                  <div class="dropdown-item" @click="toHome()">
                    <div class="btn-menu-container">
                      <span class="btn btn-md btn-success btn-menu">
                        <img src="@/assets/images/menu/inicio.png" alt height="16" />
                      </span>
                      Inicio
                    </div>
                  </div>

                  <div class="dropdown-item" @click="toHistory()">
                    <div class="btn-menu-container">
                      <span class="btn btn-md btn-success btn-menu">
                        <img src="@/assets/images/menu/historial.png" alt height="20" />
                      </span>
                      Historial
                    </div>
                  </div>

                  <div class="dropdown-item" @click="toPermissions()" v-if="canViewPermissions()">
                    <div class="btn-menu-container">
                      <span class="btn btn-md btn-success btn-menu">
                        <img src="@/assets/images/menu/permission.png" alt height="20" />
                      </span>
                      Permisos
                    </div>
                  </div>

                  <div class="dropdown-item" @click="toSchedule()">
                    <div class="btn-menu-container">
                      <span class="btn btn-md btn-success btn-menu">
                        <img src="@/assets/images/menu/Schedule.png" alt height="20" />
                      </span>
                      Mis Horarios
                    </div>
                  </div>

                  <div class="dropdown-item" @click="toProduct()">
                    <div class="btn-menu-container">
                      <span class="btn btn-md btn-success btn-menu">
                        <img src="@/assets/images/menu/productos.png" alt height="20" />
                      </span>
                      Mis platos
                    </div>
                  </div>

                  <div class="dropdown-item" @click="toSupport()">
                    <div class="btn-menu-container">
                      <span class="btn btn-md btn-success btn-menu">
                        <img src="@/assets/images/menu/soporte.png" alt height="20" />
                      </span>
                      Soporte
                    </div>
                  </div>

                  <div class="dropdown-item logout-item" @click="logout()">
                    <div class="btn-menu-container">
                      Cerrar sesión
                    </div>
                  </div>
                </div>
              </transition>

              <!-- Backdrop para cerrar al hacer clic fuera -->
              <div 
                v-if="menuOpen" 
                class="dropdown-backdrop" 
                @click="menuOpen = false"
              ></div>
            </div>

            &nbsp;

            <span class="horizontal-title">{{ firstTitle }}</span> {{ title }}
          </div>
          <div class="col-lg-6" style="text-align:right">
            <!-- No products-->
            <div class="row horizontal-openClose" v-if="path !== '/welly/products'">
              <div class="col-lg-7">
              </div>
              <div class="col-lg-4">
                <span>Restó <b>{{ stateAvailable ? 'ABIERTO' : 'CERRADO' }}</b></span>
                <br />
                <span style="color:#2DA673;" v-if="earliest && latest">{{ earliest }} a {{ latest }}</span>
              </div>
              <div class="col-lg-1 my-dish-card-activity" style="text-align:right">
                <div style="position: relative;">
                  <div @mouseenter="showTooltipErrorView = true" @mouseleave="showTooltipErrorView = false">
                    <PermissionTooltip
                      :show="showTooltipErrorView && !canUpdateStoreOpen()" 
                    />
                  <b-form class="form-check form-switch form-switch-lg">
                    <input 
                      class="form-check-input" 
                      id="input-1" 
                      type="checkbox" 
                      :disabled="!canUpdateStoreOpen()" 
                      v-model="stateAvailable"
                      @click="openPopUpConfirm" 
                    />
                  </b-form>
                  </div>
                </div>
              </div>
              <StateConfirmPopup
                :isOpen="stateAvailable"
                :isVisible="showPopUpConfirm"
                @close="showPopUpConfirm = false"
                @updateState="updateStateAvailable"
                @sendState="changeAvailable"
              />
            </div>

            <!-- Products-->
            <div class="row" v-if="path === '/welly/products'">
              <div class="col-lg-7">
              </div>
              <div class="col-lg-5">
                <b-button href="/welly/newproduct" type="submit" variant="success" class="btn-success">
                  <img src="@/assets/images/plus.svg" height="18px" />
                  Agregar producto
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <br />

      </div>
      <div class="main-content">
        <div class="page-content1">
          <div class="container-fluid">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <RightBar />
  </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/horizontal';
</style>